import {
  Truck, Plane, Ship, Boxes, Warehouse, Globe, ClipboardList,
  RefreshCw, TrendingDown, Settings2,
  Headset, Zap, Network, Radar, BadgeDollarSign, UserCheck,
} from "lucide-react";

export const NAV_LINKS = [
  { label: "Who We Are", href: "#who-we-are" },
  { label: "Services", href: "#services" },
  { label: "How We Work", href: "#how-we-work" },
  { label: "Why Choose Us", href: "#why-primelane" },
  { label: "Get in Touch", href: "#contact" },
];

export const TRUST_POINTS = [
  { title: "Domestic, Air & Ocean Freight", desc: "FTL, LTL, expedited, air and ocean freight coordination." },
  { title: "Warehouse & Cross-Docking Support", desc: "Receiving, staging, consolidation and repalletizing support." },
  { title: "Structured Supplier Follow-Up", desc: "Active PO, RFQ and shipment tracking to delivery." },
  { title: "Direct Communication", desc: "A real point of contact — never a call center." },
];

export const SERVICE_GROUPS = [
  {
    category: "Transportation",
    items: [
      {
        icon: Truck,
        title: "Freight Coordination & Brokerage",
        desc: "Domestic freight solutions including full truckload, less-than-truckload, expedited freight, carrier sourcing, pickup scheduling, delivery follow-up, shipment tracking, and exception management.",
      },
      {
        icon: Plane,
        title: "Air Shipment Coordination",
        desc: "Coordination for time-sensitive, urgent, and high-priority cargo through qualified logistics partners and air freight networks — planning, carrier communication, documentation, and delivery follow-up.",
      },
      {
        icon: Ship,
        title: "Ocean Freight Solutions",
        desc: "International logistics coordination through ocean freight partners: container movement, shipment planning, documentation follow-up, port coordination, drayage support, and final delivery.",
      },
      {
        icon: Boxes,
        title: "Freight Consolidation",
        desc: "Combining freight from multiple suppliers, origins, or locations into more efficient shipments to reduce fragmentation, improve load efficiency, and optimize transportation costs.",
      },
    ],
  },
  {
    category: "Sourcing & Procurement",
    items: [
      {
        icon: Globe,
        title: "Supply Chain Sourcing",
        desc: "Identifying, evaluating, and coordinating with potential suppliers based on product needs, pricing, lead times, minimum order quantities, quality expectations, and supply requirements.",
      },
      {
        icon: ClipboardList,
        title: "Supplier & Procurement Support",
        desc: "RFQ coordination, quote comparison, purchase order follow-up, supplier communication, lead time tracking, order status updates, vendor documentation, and supplier performance visibility.",
      },
    ],
  },
  {
    category: "Operations & Support",
    items: [
      {
        icon: Warehouse,
        title: "Warehouse & Cross-Docking Support",
        desc: "Warehouse-based logistics through operational partners in strategic markets including Miami and Jacksonville: receiving, staging, storage, cross-docking, pallet handling, repalletizing, labeling, shrink wrapping, photo confirmation, inventory reporting, and delivery coordination.",
      },
      {
        icon: RefreshCw,
        title: "Managed Logistics Support",
        desc: "Ongoing, recurring coordination across freight, suppliers, carriers, warehouse activities, shipment tracking, and operational updates — structured based on volume and customer requirements.",
      },
      {
        icon: TrendingDown,
        title: "Freight Cost Optimization",
        desc: "Identifying opportunities to reduce logistics costs through consolidation, carrier coordination, shipment planning, quote comparison, routing support, and improved transportation visibility.",
      },
      {
        icon: Settings2,
        title: "Customized Supply Chain Solutions",
        desc: "Tailored logistics and supply chain support based on each company's operational needs, freight volume, supplier base, warehouse requirements, service expectations, and growth strategy.",
      },
    ],
  },
];

export const SERVICE_OPTIONS = [
  "FTL",
  "LTL",
  "Expedited Freight",
  "Air Freight",
  "Ocean Freight",
  "Miami Freight Consolidation",
  "Warehouse & Cross-Docking",
  "Supplier Follow-Up",
  "Other",
];

export const STEPS = [
  { n: "01", title: "Understand Your Needs", desc: "We gather shipment details, service requirements, timelines, and any special handling needs." },
  { n: "02", title: "Source & Vet Capacity", desc: "We help source qualified carriers and logistics partners aligned with your freight requirements." },
  { n: "03", title: "Coordinate & Track", desc: "We coordinate pickup, transit, documentation, communication, and shipment updates." },
  { n: "04", title: "Deliver Results", desc: "Your freight is delivered with clear follow-up, visibility, and professional support through completion." },
];

export const VALUE_PROPS = [
  { icon: Headset, title: "24/7 Communication & Support", desc: "We're here anytime you need us." },
  { icon: Zap, title: "Responsive Support", desc: "Quick replies. Fast solutions." },
  { icon: Network, title: "Reliable Carrier Network", desc: "Trusted carriers. Consistent capacity." },
  { icon: Radar, title: "Real-Time Shipment Visibility", desc: "Track every shipment. Stay informed." },
  { icon: BadgeDollarSign, title: "Cost-Conscious Solutions", desc: "Smart solutions that help you save." },
  { icon: UserCheck, title: "Dedicated Logistics Coordination", desc: "Personalized service. End-to-end support." },
];

export const STATS = [
  { value: "48-State", label: "Nationwide Coverage" },
  { value: "500+", label: "Vetted Carrier Network" },
  { value: "24/7", label: "Shipment Visibility" },
  { value: "1:1", label: "Dedicated Coordination" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1616432043562-3671ea2e5242?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  warehouse: "/assets/warehouse.png",
  port: "https://images.unsplash.com/photo-1670121180530-cfcba4438038?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};
